module.exports = __webpack_public_path__ + "assets/img/images_l.e24379ce.png";